import { icsApi } from './api';

interface Params {
  url: string;
}

export async function del({ url }: Params): Promise<void> {
  const axiosResponse = await icsApi.delete(url);

  if (axiosResponse.status !== 200 && axiosResponse.status !== 204) {
    throw new Error(axiosResponse.data.error.message);
  }
}
